const {
  REACT_APP_ANALYTICS,
  REACT_APP_ADSERVER_DOMAIN,
  REACT_APP_AD_PREVIEW,
  REACT_APP_API_URL,
  REACT_APP_PUBLIC_API_URL,
  REACT_APP_GOOGLE_API_KEY,
  REACT_APP_GOOGLE_OAUTH_CLIENT_ID,
  REACT_APP_GOOGLE_LOGIN_ENABLED,
  REACT_APP_ADCOPY_IMAGE_FORMATS,
  REACT_APP_GRAPH_PERIOD_LENGTH,
  REACT_APP_GRAPH_DETAILS_MAX_MONTH,
  REACT_APP_GRAPH_DETAILS_OVERVIEW_MAX_MONTH,
  REACT_APP_NATIVE_TEMPLATE_PREVIEW_DEBOUNCE_TIME,
  REACT_APP_SELECTED_SEGMENTS_DEFAULT_VISIBLE,
  REACT_APP_ACTIVITY_FEED_MAX_VISIBLE_ITEM_CHANGES,
  REACT_APP_COST_ADJUSTMENT_VARIATION_STEP,
  REACT_APP_CONF_UPDATE_DELAY_MINUTES,
  REACT_APP_CONF_CHART_MAX_LINES_FOR_VALUE_DISPLAY,
  REACT_APP_ADGROUP_END_DATE_THRESHOLD_DAYS,
  REACT_APP_ADGROUP_DAILY_BUDGET_THRESHOLD,
  REACT_APP_RECOMMENDED_CPC_BY_REACH,
  REACT_APP_MAX_ADCOPY_GENERATION,
  REACT_APP_CGU_VERSION,
  REACT_APP_DOMAIN,
  REACT_APP_ENVIRON,
  REACT_APP_LLM_KEYWORDS_SUGGESTION_ENABLED,
  REACT_APP_DISABLE_AI_ASSISTANT,
  REACT_APP_GEO_LOCATION_INLINE_DISPLAY_LIMIT,
  REACT_APP_SEASONAL_LOGO_APPEARANCE_PERCENT,
} = import.meta.env

if (!REACT_APP_API_URL) throw 'Application configuration fails: REACT_APP_API_URL is missing'
if (!REACT_APP_PUBLIC_API_URL)
  throw 'Application configuration fails: REACT_REACT_APP_PUBLIC_API_URLAPP_API_URL is missing'
if (!REACT_APP_GOOGLE_API_KEY) throw 'Application configuration fails: REACT_APP_GOOGLE_API_KEY is missing'
export const GOOGLE_LOGIN_ENABLED: boolean = REACT_APP_GOOGLE_LOGIN_ENABLED !== 'false'
if (GOOGLE_LOGIN_ENABLED && !REACT_APP_GOOGLE_OAUTH_CLIENT_ID)
  throw 'Application configuration fails: REACT_APP_GOOGLE_OAUTH_CLIENT_ID is missing'
if (!REACT_APP_ANALYTICS) throw 'Application configuration fails: REACT_APP_ANALYTICS is missing'
if (!REACT_APP_ADSERVER_DOMAIN) throw 'Application configuration fails: REACT_APP_ADSERVER_DOMAIN is missing'
if (!REACT_APP_AD_PREVIEW) throw 'Application configuration fails: REACT_APP_AD_PREVIEW is missing'
if (!REACT_APP_ADCOPY_IMAGE_FORMATS) throw 'Application configuration fails: REACT_APP_ADCOPY_IMAGE_FORMATS is missing'
if (!REACT_APP_GRAPH_PERIOD_LENGTH) throw 'Application configuration fails: REACT_APP_GRAPH_PERIOD_LENGTH is missing'
if (!REACT_APP_GRAPH_DETAILS_MAX_MONTH)
  throw 'Application configuration fails: REACT_APP_GRAPH_DETAILS_MAX_MONTH is missing'
if (!REACT_APP_GRAPH_DETAILS_OVERVIEW_MAX_MONTH)
  throw 'Application configuration fails: REACT_APP_GRAPH_DETAILS_OVERVIEW_MAX_MONTH is missing'
if (!REACT_APP_NATIVE_TEMPLATE_PREVIEW_DEBOUNCE_TIME)
  throw 'Application configuration fails: REACT_APP_NATIVE_TEMPLATE_PREVIEW_DEBOUNCE_TIME is missing'
if (!REACT_APP_SELECTED_SEGMENTS_DEFAULT_VISIBLE)
  throw 'Application configuration fails: REACT_APP_SELECTED_SEGMENTS_DEFAULT_VISIBLE is missing'
if (!REACT_APP_ACTIVITY_FEED_MAX_VISIBLE_ITEM_CHANGES)
  throw 'Application configuration fails: REACT_APP_ACTIVITY_FEED_MAX_VISIBLE_ITEM_CHANGES is missing'
if (!REACT_APP_COST_ADJUSTMENT_VARIATION_STEP)
  throw 'Application configuration fails: REACT_APP_COST_ADJUSTMENT_VARIATION_STEP is missing'
if (!REACT_APP_CONF_UPDATE_DELAY_MINUTES)
  throw 'Application configuration fails: REACT_APP_CONF_UPDATE_DELAY_MINUTES is missing'
if (!REACT_APP_CONF_CHART_MAX_LINES_FOR_VALUE_DISPLAY)
  throw 'Application configuration fails: REACT_APP_CONF_CHART_MAX_LINES_FOR_VALUE_DISPLAY is missing'
if (!REACT_APP_ADGROUP_END_DATE_THRESHOLD_DAYS)
  throw 'Application configuration fails: REACT_APP_ADGROUP_END_DATE_THRESHOLD_DAYS is missing'
if (!REACT_APP_ADGROUP_DAILY_BUDGET_THRESHOLD)
  throw 'Application configuration fails: REACT_APP_ADGROUP_DAILY_BUDGET_THRESHOLD is missing'
if (!REACT_APP_RECOMMENDED_CPC_BY_REACH)
  throw 'Application configuration fails: REACT_APP_RECOMMENDED_CPC_BY_REACH is missing'

export interface RecommendedCpcByReachBand {
  minReach: number
  minCpc: number
  maxCpc: number
}

const parseRecommendedCpcByReach = (raw: string): RecommendedCpcByReachBand[] => {
  let parsed: unknown
  try {
    parsed = JSON.parse(raw)
  } catch {
    throw 'Application configuration fails: REACT_APP_RECOMMENDED_CPC_BY_REACH is not valid JSON'
  }
  if (!Array.isArray(parsed) || parsed.length === 0)
    throw 'Application configuration fails: REACT_APP_RECOMMENDED_CPC_BY_REACH must be a non-empty array'

  const bands = parsed.map((entry, index) => {
    if (entry === null || typeof entry !== 'object')
      throw `Application configuration fails: REACT_APP_RECOMMENDED_CPC_BY_REACH entry ${index} must be an object`
    const { minReach, minCpc, maxCpc } = entry as Record<string, unknown>
    if (typeof minReach !== 'number' || typeof minCpc !== 'number' || typeof maxCpc !== 'number')
      throw `Application configuration fails: REACT_APP_RECOMMENDED_CPC_BY_REACH entry ${index} must have numeric minReach, minCpc, maxCpc`
    return { minReach, minCpc, maxCpc }
  })

  return bands.sort((a, b) => b.minReach - a.minReach)
}

if (!REACT_APP_MAX_ADCOPY_GENERATION)
  throw 'Application configuration fails: REACT_APP_MAX_ADCOPY_GENERATION is missing'
if (!REACT_APP_CGU_VERSION) throw 'Application configuration fails: REACT_APP_CGU_VERSION is missing'
if (!REACT_APP_DOMAIN) throw 'Application configuration fails: REACT_APP_DOMAIN is missing'
const allowedEnvironmentValues = ['production', 'development', 'vitest'] as const
const appEnviron = REACT_APP_ENVIRON ?? 'production'
if (!allowedEnvironmentValues.includes(appEnviron))
  throw "Application configuration fails: REACT_APP_ENVIRON must be one of 'production', 'development', 'vitest'"
export const API_URL: string = REACT_APP_API_URL
export const PUBLIC_API_URL: string = REACT_APP_PUBLIC_API_URL
export const GOOGLE_API_KEY: string = REACT_APP_GOOGLE_API_KEY
export const GOOGLE_OAUTH_CLIENT_ID: string = REACT_APP_GOOGLE_OAUTH_CLIENT_ID ?? ''
export const APP_ANALYTICS: string = REACT_APP_ANALYTICS
export const ADSERVER_DOMAIN: string = REACT_APP_ADSERVER_DOMAIN
export const AD_PREVIEW: string = REACT_APP_AD_PREVIEW
export const ADCOPY_IMAGE_FORMATS: string = REACT_APP_ADCOPY_IMAGE_FORMATS
export const GRAPH_PERIOD_LENGTH: number = parseInt(REACT_APP_GRAPH_PERIOD_LENGTH)
export const GRAPH_DETAILS_MAX_MONTH: number = parseInt(REACT_APP_GRAPH_DETAILS_MAX_MONTH)
export const GRAPH_DETAILS_OVERVIEW_MAX_MONTH: number = parseInt(REACT_APP_GRAPH_DETAILS_OVERVIEW_MAX_MONTH)
export const NATIVE_TEMPLATE_PREVIEW_DEBOUNCE_TIME: number = parseInt(REACT_APP_NATIVE_TEMPLATE_PREVIEW_DEBOUNCE_TIME)
export const SELECTED_SEGMENTS_DEFAULT_VISIBLE: number = parseInt(REACT_APP_SELECTED_SEGMENTS_DEFAULT_VISIBLE)
export const ACTIVITY_FEED_MAX_VISIBLE_ITEM_CHANGES: number = parseInt(REACT_APP_ACTIVITY_FEED_MAX_VISIBLE_ITEM_CHANGES)
export const COST_ADJUSTMENT_VARIATION_STEP: number = parseInt(REACT_APP_COST_ADJUSTMENT_VARIATION_STEP)
export const CONF_UPDATE_DELAY_MINUTES: number = parseInt(REACT_APP_CONF_UPDATE_DELAY_MINUTES)
export const CONF_CHART_MAX_LINES_FOR_VALUE_DISPLAY: number = parseInt(REACT_APP_CONF_CHART_MAX_LINES_FOR_VALUE_DISPLAY)
export const ADGROUP_END_DATE_THRESHOLD_DAYS: number = parseInt(REACT_APP_ADGROUP_END_DATE_THRESHOLD_DAYS)
export const ADGROUP_DAILY_BUDGET_THRESHOLD: number = parseInt(REACT_APP_ADGROUP_DAILY_BUDGET_THRESHOLD)
export const RECOMMENDED_CPC_BY_REACH: RecommendedCpcByReachBand[] = parseRecommendedCpcByReach(
  REACT_APP_RECOMMENDED_CPC_BY_REACH
)
export const MAX_ADCOPY_GENERATION: number = parseInt(REACT_APP_MAX_ADCOPY_GENERATION)
export const CGU_VERSION: string = REACT_APP_CGU_VERSION
export const DOMAIN: string = REACT_APP_DOMAIN
export const ENVIRON: (typeof allowedEnvironmentValues)[number] = appEnviron
export const LLM_KEYWORDS_SUGGESTION_ENABLED =
  REACT_APP_LLM_KEYWORDS_SUGGESTION_ENABLED != undefined && REACT_APP_LLM_KEYWORDS_SUGGESTION_ENABLED === 'true'
export const DISABLE_AI_ASSISTANT = REACT_APP_DISABLE_AI_ASSISTANT === 'true'
export const GEO_LOCATION_INLINE_DISPLAY_LIMIT: number = REACT_APP_GEO_LOCATION_INLINE_DISPLAY_LIMIT
  ? parseInt(REACT_APP_GEO_LOCATION_INLINE_DISPLAY_LIMIT, 10)
  : 30
/** Percent from 0 to 100. The seasonal logo plays once on load when the roll lands inside it. */
export const SEASONAL_LOGO_APPEARANCE_PERCENT: number = REACT_APP_SEASONAL_LOGO_APPEARANCE_PERCENT
  ? parseInt(REACT_APP_SEASONAL_LOGO_APPEARANCE_PERCENT, 10)
  : 0
